import React from "react";
import { Page } from "components/support";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Filter from "./filter";
import { Loadable } from "components/support";
import HistoryGraph from "./history-graph/view";
import QuickCards from "./quick-cards/view";
import MostProfitable from "./most-profitable/view";
import MostSold from "./most-sold/view";

const DashboardView = ({ presenter, viewModel }) => {
  const { filters, loading, results, dataGraph } = viewModel;
  return (
    <Page>
      <Loadable loading={loading}>
        <Row>
          <Col xs>
            <Typography type="display1" className="pb-sm">
              Painel de Resultados
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Filter
              filters={filters}
              onChange={filters => presenter.onFilterChange(filters)}
            />
          </Col>
        </Row>
        <Row style={marginTopStyle}>
          <Col xs={12}>
            <HistoryGraph
              result={results}
              dataGraph={dataGraph}
              onTouchTap={() => presenter.onOpenSalesReport()}
            ></HistoryGraph>
          </Col>
        </Row>
        <Row style={marginTopStyle}>
          <Col xs={12}>
            <QuickCards result={results}></QuickCards>
          </Col>
        </Row>
        <Row style={marginTopStyle}>
          <Col xs={12} lg={6}>
            <MostProfitable result={results}></MostProfitable>
          </Col>
          <Col xs={12} lg={6}>
            <MostSold result={results}></MostSold>
          </Col>
        </Row>
      </Loadable>
    </Page>
  );
};

const marginTopStyle = {
  marginTop: 24
};

export default DashboardView;



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/view.jsx